import type { ResultOf, VariablesOf } from '@graphql-typed-document-node/core';

import { input } from '../../common/requests/base.input.ts';
import { mutation } from '../../common/requests/base.mutation.ts';
import { ResultType } from '../../main/types/result.types.ts';
import { getReadingCrittersClientUtil } from '../../main/utils/clients/readingcritters.client.util.ts';

const UPDATE_PARENT_ACCOUNT_MUTATION = mutation({
  updateParentAccount: [
    { input: input('input', 'UpdateParentAccountInput!') },
    {
      success: true,
    },
  ],
});

type UpdateParentAccountInputType = VariablesOf<typeof UPDATE_PARENT_ACCOUNT_MUTATION>['input'];
type UpdateParentAccountResponseType = ResultOf<typeof UPDATE_PARENT_ACCOUNT_MUTATION>['updateParentAccount'];

export const updateParentAccountMutationRequest = async (
  props: UpdateParentAccountInputType
): Promise<ResultType<UpdateParentAccountResponseType>> => {
  const client = getReadingCrittersClientUtil();

  try {
    const response = await client.mutation(UPDATE_PARENT_ACCOUNT_MUTATION, { input: props }, { useAuth: true });

    return {
      success: Boolean(response?.updateParentAccount?.success),
      data: response?.updateParentAccount ?? { success: false },
    };
  } catch (error) {
    return {
      success: false,
      message: (error as Error).message,
    };
  }
};
